import $ from 'jquery';

$(document).ready(() => {
  const questionForms = document.querySelectorAll('.js-question-form');

  questionForms.forEach((questionForm) => {
    const questionFormBlock = questionForm.querySelector('.js-question-form-block');

    if (!questionFormBlock) return;

    const questionBlockForm = questionFormBlock.querySelector('.wpcf7');
    const questionFormCollapse = questionForm.querySelector('.js-question-form-collapse-button');
    const activeFormClass = 'question-form__block--active';
    const activeButtonClass = 'question-form__collapse-button--active';

    questionBlockForm.addEventListener('click', () => {
      questionFormBlock.classList.add(activeFormClass);
      questionFormCollapse.classList.add(activeButtonClass);
    });

    questionFormCollapse.addEventListener('click', () => {
      if (questionFormBlock.classList.contains(activeFormClass)) {
        questionFormBlock.classList.remove(activeFormClass);
        questionFormCollapse.classList.remove(activeButtonClass);

        window.scrollTo({
          top: questionForm.offsetTop + questionForm.scrollHeight + 20,
          behavior: 'smooth',
        });
      } else {
        questionFormBlock.classList.add(activeFormClass);
        questionFormCollapse.classList.add(activeButtonClass);
      }
    });
  });
});
